import { useEffect, useState } from "react";
import { GuidePostService } from "@oldDashboard/legacyServices/guide-posts/guidePostService";
import { setLaunchGoalAction } from "@oldDashboard/legacyActions/dashboardClient";

interface useLaunchGoalProps { affiliateSelected: String, launchSelected: String, timePeriodSelected: String, searching: boolean }

const useLaunchGoal = (props: useLaunchGoalProps) => {
    const { affiliateSelected, launchSelected, timePeriodSelected, searching } = props;
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        fetchLaunchGoal();
    },[launchSelected, searching]);

    const fetchLaunchGoal = async() => {
        setIsLoading(true);
        try {
            const service = new GuidePostService();
            await service.getLaunchGoal(affiliateSelected, launchSelected, timePeriodSelected).then((response)=>{
                if(response.success){
                    if(response.chart_data.data) {
                        setLaunchGoalAction(response.chart_data.data.launch_goal);
                    } else
                        setLaunchGoalAction("-");
                }
            });

        } catch (error: any) {
            console.log("ERROR ", error)
        } finally {
         setIsLoading(false);
        }
      
    }
    return { isLoading, fetchLaunchGoal }
}

export default useLaunchGoal